import cx from "classnames";
import { Spinner } from "../../Atoms";
import { defaultProps, FallBackSpinnerProps } from "./FallBackSpinner.type";
import styles from "./FallBackSpinner.module.scss";

export const FallBackSpinner = (props: FallBackSpinnerProps) => {
	const { className, ...attributes } = { ...defaultProps, ...props }

	return (
		<div className={cx(styles.FallBackSpinner, className)} {...attributes}>
			<Spinner size="large" />
		</div>
	)
};
